export default __webpack_public_path__ + "static/media/AMNH_13.a5ae79bd.png";